var React = require('react');

function Present (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m219.4 30.5c-4.5 0-8.5 2.3-10.9 5.8-2.2-2.4-5.4-3.9-8.9-3.9-6.7 0-12.3 5.5-12.3 12.3 0 2.4.7 4.7 1.9 6.6h-19.9c-1.5 0-2.8 1.3-2.8 2.8v17c0 1.5 1.3 2.8 2.8 2.8h2.8v38.7c0 1.5 1.3 2.8 2.8 2.8h68c1.5 0 2.8-1.3 2.8-2.8v-38.7h2.8c1.5 0 2.8-1.3 2.8-2.8v-17c0-1.5-1.3-2.8-2.8-2.8h-18.4c1.5-2.1 2.4-4.8 2.4-7.6.1-7.2-5.8-13.2-13.1-13.2zm0 5.7c4.2 0 7.6 3.3 7.6 7.6s-3.3 7.6-7.6 7.6h-7.6c0-2.5 0-5 0-7.6 0-4.3 3.4-7.6 7.6-7.6zm-19.8 1.9c3.7 0 6.6 2.9 6.6 6.6v6.6h-6.6c-3.7 0-6.6-2.9-6.6-6.6s2.9-6.6 6.6-6.6zm-27.4 18.8h34v11.3c-11.3 0-22.7 0-34 0zm39.6 0h34v11.3c-11.3 0-22.7 0-34 0zm-34 17h28.3v35.9h-28.3zm34 0h28.3v35.9h-28.3z","fill":"#006aff","transform":"translate(-145 -10)"}));
}

Present.defaultProps = {"enableBackground":"new 0 0 128 128","viewBox":"0 0 128 128"};

module.exports = Present;

Present.default = Present;
